<template>
	<v-btn	id="clipboard"
	
			class="customVBtn"
			icon
			:data-clipboard-text="text">
		<v-icon>content_copy</v-icon>
	</v-btn>
</template>

<script>
	export default {
		name: 'ClipboardButton',
		props: {
			text: String,
		},
		data() {
			return {
				clipboard_: null
			}
		},
		mounted() {
			const self_ = this;
			// clipboard
			self_.clipboard_ = new self_.clipboard('#clipboard')
			self_.clipboard_.on('success', e => self_.$_sb_seccess(e))
			self_.clipboard_.on('error', e => self_.$_sb_error(e))
		},
		methods: {
			$_sb_seccess(e) {
				const self_ = this;
				// show snackbar
				self_.showSnackbar({ text: 'Copied to clipboard.' })
			},
			$_sb_error(e) {
				const self_ = this;
/* error */		self_.logError('Error', 'Failed to copy to clipboard.', { Action: e.action, Trigger: e.trigger })
			}
		}
	}
</script>

<style scoped>
	.icon_ {
		margin: 0 12px;
	}
	.button_ {
		margin-left: 0 !important;
		text-transform: none;
	}
</style>